import HomeComponentsContainer from './home_components_container';

export default HomeComponentsContainer;
